module.exports = __webpack_public_path__ + "img/Garage-Door_Pairing-Mode_Animation_poster.da8de103.png";